/** The stable reason codes of a decision that passes four eyes with one operator. */
export const SELF_APPROVALS = ['SUPER_ADMIN_SELF_APPROVAL'];
export const SUPER_ADMIN_SELF_APPROVAL = 'SUPER_ADMIN_SELF_APPROVAL';
export const isSelfApproval = (v) => typeof v === 'string' && SELF_APPROVALS.includes(v);
/** True when the grants hold an active GLOBAL SUPER_ADMIN with no access profile (a profile narrows the role to its own words). */
export function isGlobalSuperAdmin(grants) {
    return grants.some((g) => g.role === 'SUPER_ADMIN' && g.scopeType === 'GLOBAL' && g.profile === undefined);
}
/** The self-approval an operator with these grants may use, or undefined (four eyes applies). */
export function selfApprovalFor(grants) {
    return isGlobalSuperAdmin(grants) ? SUPER_ADMIN_SELF_APPROVAL : undefined;
}
/**
 * The four-eyes rule with its one exception. `sameActor` is the domain's own comparison of the maker and the decider (each
 * domain keeps its id canonicalisation); `selfApproval` is what the route resolved for the decider (`selfApprovalFor`).
 * A distinct decider is allowed and records nothing; the maker deciding is allowed only with a self-approval, which the
 * caller then records on the decision.
 */
export function fourEyes(sameActor, selfApproval) {
    if (!sameActor)
        return { ok: true };
    return selfApproval !== undefined && isSelfApproval(selfApproval) ? { ok: true, selfApproval } : { ok: false };
}
//# sourceMappingURL=self-approval.js.map